import FeatureRow from "@/components/feature-row";
import { FEATURES } from "@/lib/constants";

function Features() {
  return (
    <section
      id="how-it-works"
      className="flex-gap-md relative z-10  container mx-auto flex w-full flex-col items-center md:max-w-6xl"
    >
      {FEATURES.map((feature) => (
        <FeatureRow key={feature.heading} {...feature} />
      ))}
    </section>
  );
}

export default Features;
